// @flow

// Effect Managers
import { fork } from 'redux-saga/effects'

// Sagas
import { default as watchCenterMapToFarm } from './watchCenterMapToFarm'
import { default as watchCenterMapToField } from './watchCenterMapToField'
import watchCenterMapDefault from './watchCenterMapDefault'

export default function *handleMapCentering (): Generator<*, *, *> {
  yield fork(watchCenterMapDefault)
  yield fork(watchCenterMapToFarm)
  yield fork(watchCenterMapToField)
}
